import { useLocation, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Press } from '@dorixona/ui'
import { useBackButton } from '../app/useBackButton'
import { Icon } from './Icon'

export interface BackButtonProps {
  /** Родительский экран: сюда ведёт стрелка, если пришли по прямой ссылке. */
  to: string
  /** Свой шаг назад вместо перехода — например, шаги входа. */
  onBack?: () => void
}

/**
 * Стрелка «назад» у экранов, в которые переходят (товар, заказ, кабинет,
 * оформление). У вкладок нижней панели её нет: оттуда возвращаться некуда.
 * Ведёт туда, откуда пришли; если экран открыли ссылкой и истории нет —
 * на родительский. В Telegram та же команда висит на его системной кнопке.
 */
export function BackButton({ to, onBack }: BackButtonProps) {
  const navigate = useNavigate()
  const location = useLocation()
  const { t } = useTranslation('common')

  const back = () => {
    if (onBack) onBack()
    // У первой записи истории ключ «default»: шага назад внутри приложения нет.
    else if (location.key === 'default') void navigate(to)
    else void navigate(-1)
  }
  useBackButton(back)

  return (
    <Press squish="icon" className="back" aria-label={t('actions.back')} onPress={back}>
      <Icon name="i-back" size={20} />
    </Press>
  )
}
